import axios from "axios";
import api from "@/data/services/api";
import { LearningMapper } from "../mapper/learning.mapper";

export class LearningService {
  getLearningPath(slug, loggedIn) {

    let promise = (loggedIn === true)
      ? api.get(`/quiz/lessonPathProgress/${slug}`)
      : axios.get(`https://academy.coin-aholic.com/wp-json/api/v1/learning_path?post=${slug}`)

    return promise
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          console.log('response == > ', response.data.data)
          console.log('response == > ', response)
          const payload = (Array.isArray(response.data.data)) ? response.data.data[0] : response.data.data
          return LearningMapper.mapToLearningPathDetail(payload);
        } else {
          throw 'Error: Wrong Status';
        }
      });
  }
}
